import { IApplicationState } from '../../types/redux';

/**
 * Выбирает статьи автора
 */
export const selectAuthorArticles = ({ authorArticles }: IApplicationState) => authorArticles.items;
